"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = '17.0.0'; // PLEASE DONT UPDATE THIS!!! - will be updated at build time with the correct version
